module.exports = __webpack_public_path__ + "img/upgrade-to-pro.1710cec2.svg";